import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { usePrinter } from '@/hooks/usePrinter';
import { CheckCircle2, XCircle, Loader2, Wifi } from 'lucide-react';

interface PrinterConnectionTestProps {
  ip: string;
  tipo: string;
}

export function PrinterConnectionTest({ ip, tipo }: PrinterConnectionTestProps) {
  const { testarConexao, loading, error } = usePrinter(ip, tipo);
  const [success, setSuccess] = useState<boolean | null>(null);

  const handleTest = async () => {
    const isConnected = await testarConexao();
    setSuccess(isConnected);
  };

  if (!ip) return null;

  return (
    <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100 mt-2">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <Wifi className="h-4 w-4 text-gray-400" />
          <span className="text-xs font-medium text-gray-700 truncate">
            {ip} ({tipo})
          </span>
        </div>
        {success === true && (
          <p className="text-[10px] text-green-600 font-semibold mt-1 flex items-center gap-1">
            <CheckCircle2 className="h-3 w-3" /> Conectado localmente
          </p>
        )}
        {success === false && (
          <p className="text-[10px] text-red-600 font-semibold mt-1 flex items-center gap-1">
            <XCircle className="h-3 w-3" /> Sem resposta local
          </p>
        )}
        {error && <p className="text-[10px] text-red-500 mt-1">{error}</p>}
      </div>
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={handleTest} 
        disabled={loading}
        className="h-8 text-xs"
      >
        {loading ? (
          <Loader2 className="h-3 w-3 animate-spin" />
        ) : (
          'Testar'
        )}
      </Button>
    </div>
  );
}
